import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { FormattedMessage } from 'react-intl'
import { isEmpty } from 'lodash-es'

import {
  LoaderWrapperComponent,
  AlertComponent,
  InfiniteListComponent,
} from '../../../../../sharedLegacy/components'

import './AudienceInsetComponent.scss'

class AudienceInsetComponent extends React.Component {
  componentDidMount() {
    const { visibleTabList, tab, objectId, insetInit } = this.props
    let defaultTab = 'everybody'

    if (visibleTabList.includes(tab)) {
      defaultTab = tab
    }

    insetInit(defaultTab, objectId)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { tab, tabRouteChange, objectId } = this.props

    if (nextProps.tab !== tab) {
      tabRouteChange(nextProps.tab, objectId)
    }
  }

  componentWillUnmount() {
    const { insetLeave } = this.props

    insetLeave()
  }

  renderProfiles() {
    const {
      timelines,
      profiles,
      loadingStates,
      selectedTab,
      heatMapType,
      onFollowToggle,
      subscriptionStates,
      identityOptions,
      customProfileComponentProps,
      noEmptyState,
      customEmptyText,
      onOrderChange,
      style,
      profileComponent: ProfileComponent,
    } = this.props

    if (loadingStates[selectedTab] === 'failed') {
      return (
        <AlertComponent
          className="fetch-error"
          message="An error occurred when loading profiles."
          type="error"
        />
      )
    }

    const listItemsProp = timelines !== undefined ? 'timelines' : 'profiles'
    const isListEmpty =
      listItemsProp === 'profiles'
        ? // TODO (noahlaux): Refactor
          // eslint-disable-next-line react/destructuring-assignment
          this.props[listItemsProp].isEmpty()
        : // eslint-disable-next-line react/destructuring-assignment
          isEmpty(this.props[listItemsProp])

    if (isListEmpty && !noEmptyState) {
      return (
        <div className="empty-state">
          {customEmptyText || (
            <FormattedMessage defaultMessage="No matching profiles" />
          )}
        </div>
      )
    }

    return (
      <ProfileComponent
        timelines={timelines}
        heatMapType={heatMapType}
        profiles={profiles}
        onFollowToggle={onFollowToggle}
        subscriptionStates={subscriptionStates}
        identityOptions={identityOptions}
        onOrderChange={onOrderChange}
        style={style}
        {...customProfileComponentProps}
      />
    )
  }

  render() {
    const {
      selectedTab,
      objectId,
      loadingStates,
      onInfiniteLoad,
      isInfiniteLoading,
      hasMoreElements,
    } = this.props

    const isLoading = loadingStates[selectedTab] === 'loading'

    return (
      <div className="audience-inset-component">
        <div className="timelines">
          <LoaderWrapperComponent loading={isLoading}>
            <InfiniteListComponent
              onInfiniteLoad={() => onInfiniteLoad(selectedTab, objectId)}
              isInfiniteLoading={isInfiniteLoading}
              hasMoreElements={hasMoreElements[selectedTab]}
            >
              {this.renderProfiles()}
            </InfiniteListComponent>
          </LoaderWrapperComponent>
        </div>
      </div>
    )
  }
}

AudienceInsetComponent.propTypes = {
  insetInit: PropTypes.func.isRequired,
  insetLeave: PropTypes.func,
  onInfiniteLoad: PropTypes.func,
  isInfiniteLoading: PropTypes.bool,
  hasMoreElements: PropTypes.object,
  tabRouteChange: PropTypes.func.isRequired,
  tab: PropTypes.string,
  objectId: PropTypes.number,
  objectType: PropTypes.oneOf(['photo', 'live']),
  selectedTab: PropTypes.string.isRequired,
  timelines: PropTypes.arrayOf(PropTypes.object),
  profiles: ImmutablePropTypes.orderedMap,
  loadingStates: PropTypes.object,
  heatMapType: PropTypes.oneOf(['person', 'personvideo']),
  onFollowToggle: PropTypes.func,
  onOrderChange: PropTypes.func,
  subscriptionStates: ImmutablePropTypes.map,
  profileComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.instanceOf(React.Component),
  ]),
  customEmptyText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  identityOptions: PropTypes.shape({
    avatarSize: PropTypes.oneOf(['normal', 'large', 'small']),
    preferCorporateDetails: PropTypes.bool,
    showStats: PropTypes.bool,
  }),
  customProfileComponentProps: PropTypes.object,
  noEmptyState: PropTypes.bool,
  hideHeaderLink: PropTypes.bool,
  headerGreenColorStyle: PropTypes.bool,
  disabledTabs: PropTypes.arrayOf(PropTypes.string),
  visibleTabList: PropTypes.arrayOf(
    PropTypes.oneOf([
      'everybody',
      'webinarEverybody',
      'identified',
      'converted',
      'attendees',
      'absentees',
    ])
  ),
  style: PropTypes.object,
}

AudienceInsetComponent.defaultProps = {
  heatMapType: 'person',
  // TODO (noahlaux): Refactor with TS
  // eslint-disable-next-line react/default-props-match-prop-types
  selectedTab: 'everybody',
  identityOptions: {},
  customProfileComponentProps: {},
  noEmptyState: false,
  visibleTabList: ['everybody', 'identified', 'converted'],
}

export default AudienceInsetComponent
